import { EMBER_MIRE_SHALLOW_DOOR_ID, FROSTMERE_SHALLOW_DOOR_ID, SABLEWIND_SHALLOW_DOOR_ID, VERDANA_SHALLOW_DOOR_ID, } from '../types/expedition.js';
import { validateCanonicalRoomCatalog, } from './schema.js';
export * from './schema.js';
export const HOME_ROOM_ID = 'home';
export const TOWN_VERDANA_ROOM_ID = 'town:verdana_fields';
export const VERDANA_EXPEDITION_ROOM_ID = 'expedition:verdana_shallow';
export const SABLEWIND_EXPEDITION_ROOM_ID = 'expedition:sablewind_shallow';
export const FROSTMERE_EXPEDITION_ROOM_ID = 'expedition:frostmere_shallow';
export const EMBER_MIRE_EXPEDITION_ROOM_ID = 'expedition:ember_mire_shallow';
export const CANONICAL_LIVE_ROOM_IDS = [
    HOME_ROOM_ID,
    VERDANA_EXPEDITION_ROOM_ID,
    SABLEWIND_EXPEDITION_ROOM_ID,
    FROSTMERE_EXPEDITION_ROOM_ID,
    EMBER_MIRE_EXPEDITION_ROOM_ID,
];
export const HOME_ROOM_SPAWN = { x: 320, y: 240 };
export const TOWN_ROOM_SPAWN = { x: 480, y: 320 };
export const EXPEDITION_ROOM_SPAWN = { x: 640, y: 480 };
export const RITUAL_PROXIMITY_RADIUS_PX = 256;
export const RITUAL_DOORS = [
    {
        id: VERDANA_SHALLOW_DOOR_ID,
        x: 1024,
        y: 768,
        radiusPx: RITUAL_PROXIMITY_RADIUS_PX,
        targetRoomId: VERDANA_EXPEDITION_ROOM_ID,
    },
    {
        id: SABLEWIND_SHALLOW_DOOR_ID,
        x: 2880,
        y: 3840,
        radiusPx: RITUAL_PROXIMITY_RADIUS_PX,
        targetRoomId: SABLEWIND_EXPEDITION_ROOM_ID,
    },
    {
        id: FROSTMERE_SHALLOW_DOOR_ID,
        x: 2880,
        y: 800,
        radiusPx: RITUAL_PROXIMITY_RADIUS_PX,
        targetRoomId: FROSTMERE_EXPEDITION_ROOM_ID,
    },
    {
        id: EMBER_MIRE_SHALLOW_DOOR_ID,
        x: 4640,
        y: 2624,
        radiusPx: RITUAL_PROXIMITY_RADIUS_PX,
        targetRoomId: EMBER_MIRE_EXPEDITION_ROOM_ID,
    },
];
export const CANONICAL_ROOMS = validateCanonicalRoomCatalog({
    [HOME_ROOM_ID]: {
        id: HOME_ROOM_ID,
        kind: 'home',
        aliases: [],
        spawn: HOME_ROOM_SPAWN,
        doors: [],
        portals: [],
        wallTiles: [],
        puzzles: [],
    },
    [TOWN_VERDANA_ROOM_ID]: {
        id: TOWN_VERDANA_ROOM_ID,
        kind: 'town',
        realm: 'verdana_fields',
        aliases: ['verdana'],
        spawn: TOWN_ROOM_SPAWN,
        doors: [],
        portals: [],
        wallTiles: [],
        puzzles: [],
    },
    [VERDANA_EXPEDITION_ROOM_ID]: {
        id: VERDANA_EXPEDITION_ROOM_ID,
        kind: 'expedition',
        realm: 'verdana_fields',
        aliases: ['verdana'],
        tilemapFixture: 'expedition-verdana-shallow.json',
        deepTilemapFixture: 'expedition-verdana-deep.json',
        spawn: EXPEDITION_ROOM_SPAWN,
        doors: [RITUAL_DOORS[0]],
        portals: [],
        wallTiles: [],
        puzzles: [],
    },
    [SABLEWIND_EXPEDITION_ROOM_ID]: {
        id: SABLEWIND_EXPEDITION_ROOM_ID,
        kind: 'expedition',
        realm: 'sablewind_reaches',
        aliases: ['sablewind'],
        tilemapFixture: 'expedition-sablewind-shallow.json',
        deepTilemapFixture: 'expedition-sablewind-deep.json',
        spawn: EXPEDITION_ROOM_SPAWN,
        doors: [RITUAL_DOORS[1]],
        portals: [],
        wallTiles: [],
        puzzles: [],
    },
    [FROSTMERE_EXPEDITION_ROOM_ID]: {
        id: FROSTMERE_EXPEDITION_ROOM_ID,
        kind: 'expedition',
        realm: 'frostmere_expanse',
        aliases: ['frostmere'],
        tilemapFixture: 'expedition-frostmere-shallow.json',
        deepTilemapFixture: 'expedition-frostmere-deep.json',
        spawn: EXPEDITION_ROOM_SPAWN,
        doors: [RITUAL_DOORS[2]],
        portals: [],
        wallTiles: [],
        puzzles: [],
    },
    [EMBER_MIRE_EXPEDITION_ROOM_ID]: {
        id: EMBER_MIRE_EXPEDITION_ROOM_ID,
        kind: 'expedition',
        realm: 'ember_mire',
        aliases: ['embermire'],
        tilemapFixture: 'expedition-ember-mire-shallow.json',
        deepTilemapFixture: 'expedition-ember-mire-deep.json',
        spawn: EXPEDITION_ROOM_SPAWN,
        doors: [RITUAL_DOORS[3]],
        portals: [],
        wallTiles: [],
        puzzles: [],
    },
});
export function getCanonicalRoom(roomId) {
    return CANONICAL_ROOMS[roomId] ?? null;
}
export function getCanonicalRoomForRealm(realm) {
    const normalized = realm.trim();
    for (const room of Object.values(CANONICAL_ROOMS)) {
        if (room.kind !== 'expedition')
            continue;
        if (room.realm === normalized || room.aliases.includes(normalized)) {
            return room;
        }
    }
    return CANONICAL_ROOMS[VERDANA_EXPEDITION_ROOM_ID];
}
export function getRitualDoor(doorId) {
    return RITUAL_DOORS.find((door) => door.id === doorId) ?? null;
}
//# sourceMappingURL=index.js.map